<script>
  import Icon from '@ui/pico/icon.svelte';
  import Inline from '@ui/pico/inline.svelte';
  import { noop } from 'svelte/internal';

  // NOTE: nbsp; used to preserve height when hidden
  export let showMode = false;
  export let mode = 'overview';
  export let onOverviewClick = noop;
  export let onListClick = noop;

  let active = (thisMode) => (thisMode === mode ? 'active' : '');
  let modeName;
  $: {
    if (mode === 'overview') {
      modeName = 'Overview Mode';
    }
    if (mode === 'list') {
      modeName = 'List Mode';
    }
  }
</script>

<div class="mode-toggle">
  <small>
    {#if showMode}
      {modeName}
    {:else}
      &nbsp;
    {/if}
  </small>
  <Inline>
    <span
      class="mode {active('list')}"
      slot="right"
      on:click={onListClick}
      on:keyup={null}
    >
      <Icon name="list" size={32} />
    </span>
    <span
      class="mode {active('overview')}"
      slot="left"
      on:click={onOverviewClick}
      on:keyup={null}
    >
      <Icon name="file-text" size={32} />
    </span>
  </Inline>
</div>

<style>
  .mode-toggle {
    display: flex;
    width: 100%;
    justify-content: flex-end;
  }
  small {
    opacity: 0.5;
    padding: 0.5rem;
  }
  span[slot] {
    border: solid transparent;
    border-radius: 12px;
    padding: 0.8rem 1rem 1rem;
  }
  span[slot].active {
    border-color: var(--primary);
  }
  span[slot]:hover {
    border-color: var(--primary);
  }
  span.mode {
    margin-left: 0.5rem;
  }
</style>
